import {useFormik} from "formik";
import {useState} from "react";
import {Button, Tooltip} from "@chakra-ui/react";

export const VerifyEmailForm = (
  {startValue, onSubmit, formActive}: {
    startValue: string | null | undefined,
    formActive: boolean
    onSubmit: (email: string) => Promise<void>
  }) => {
  // Pass the useFormik() hook initial form values and a submit function that will
  // be called when the form is submitted
  const [processing, setProcessing] = useState(false)

  const formik = useFormik({
    initialValues: {
      email: startValue || '',
    },
    onSubmit: values => {
      setProcessing(true)
      if (onSubmit) {
        onSubmit(values.email)
          .finally(() => setProcessing(false))
      }
    },
  });
  return (
    <form
      className={"mt-5 sm:flex sm:items-center"}
      onSubmit={formik.handleSubmit}>
      <div
        className="w-full sm:max-w-xs relative border border-gray-300 rounded-md px-3 py-2 shadow-sm focus-within:ring-1 focus-within:ring-indigo-600 focus-within:border-indigo-600"
      >
        <label htmlFor="email"
          className="absolute -top-2 left-2 -mt-px inline-block px-1 bg-white text-xs font-medium text-gray-900">
          Email Address
        </label>

        <input
          className="block w-full border-0 p-0 text-gray-900 placeholder-gray-500 focus:ring-0 sm:text-sm"
          id="email"
          name="email"
          type="email"
          onChange={formik.handleChange}
          value={formik.values.email}
        />

      </div>

      <Tooltip isDisabled={formActive} hasArrow bg={"pink.500"} label={"This is premium feature. Upgrade to enable."}>
        <Button marginX={[0, 0, 4]} marginY={[4, 4, 0]}
          isDisabled={!formActive}
          type={"submit"}
          variant={"solid"} size={"sm"} colorScheme={"blue"}
        >
          <span>{processing ? "Processing" : "Send verification email"}</span>
        </Button>
      </Tooltip>
    </form>
  );
};

